/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import ResultConfigurationMenu from './ResultConfigurationMenu';
import VisualizationTypeMenu from './VisualizationTypeMenu';
import DeleteConfigurationMenu from './DeleteConfigurationMenu';
import CardAnnotationsMenu from './CardAnnotationsMenu';
import CardExportMenu from './CardExportMenu';
import LoadingMenu from './LoadingMenu';
import ToggleMenu from './ToggleMenu';
import * as Ui from './styles';
import ColorSchemeMenu from './ColorSchemeMenu';
import CardFontsMenu from './CardFontsMenu';
import CardOrderMenu from './CardOrderMenu';

const propTypes = {
  /**
   * define se há um carregamento em curso
   */
  loading: PropTypes.bool,
  /**
   * listener para participar do acionamento do botão fechar
   */
  onClose: PropTypes.func,
  /**
   * Itens do menu que devem ser exibidos
   */
  itemsMenu: PropTypes.array,

  withData: PropTypes.bool,

  withSettings: PropTypes.bool,
};

const defaultProps = {
  loading: false,
  onClose: null,
  itemsMenu: [],
  withData: false,
  withSettings: false,
};

function CardSettings(props) {
  // props from parent
  const { onClose, itemsMenu, loading, withData, withSettings } = props;

  // refs
  const settingRef = useRef(null);

  // calbacks: handle close settings
  const handleClose = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  /**
   * Registrando listeners para fechar automaticamente o
   * seletor caso ocorra click fora do componente
   */
  useEffect(() => {
    function handleClickOutside(event) {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        handleClose();
      }
    }
    // ao tocar fora
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [settingRef, handleClose]);

  // menu-structure: {togglebtn = {type, key, onclick}}
  function renderSettinsMenu() {
    return (itemsMenu && itemsMenu.length === 0) ? '' : itemsMenu.map((item) => {
      //
      if (item.type === 'charttypes') {
        return (
          <VisualizationTypeMenu
            key={item.key}
            className="settings-item"
            types={item.data}
            onTypeChange={item.onSelect}
            initialTypeIndex={item.selectedIndex}
            withData={withData}
          />
        );
      }

      if (item.type === 'annotations') {
        return (
          <CardAnnotationsMenu
            key={item.key}
            className="settings-item"
            onTypeChange={item.onSelect}
            onMenuClick={item.onClick}
          />
        );
      }

      if (item.type === 'chartorder') {
        return (
          <CardOrderMenu
            key={item.key}
            className="settings-item"
            types={item.data}
            onTypeChange={item.onSelect}
            initialTypeIndex={item.selectedIndex}
            withData={withData}
          />
        );
      }

      if (item.type === 'colorscheme') {
        return (
          <ColorSchemeMenu
            key={item.key}
            className="settings-item"
            types={item.data}
            onTypeChange={item.onSelect}
            initialTypeIndex={item.selectedIndex}
            withData={withData}
          />
        );
      }

      if (item.type === 'chartfonts') {
        return (
          <CardFontsMenu
            key={item.key}
            className="settings-item"
            types={item.data}
            onTypeChange={item.onSelect}
            initialTypeIndex={item.selectedIndex}
            withData={withData}
          />
        );
      }

      if (item.type === 'exportChart') {
        return (
          <CardExportMenu
            key={item.key}
            className="settings-item"
            onTypeChange={item.onSelect}
            onMenuClick={item.onClick}
          />
        );
      }

      if (item.type === 'togglebtn') {
        return (
          <ToggleMenu
            key={item.key}
            initialChecked={item.checked}
            className="settings-item"
            onChange={item.onClick}
          />
        );
      }

      if (item.type === 'deleteItem') {
        return (
          <DeleteConfigurationMenu
            key={item.key}
            className="settings-item"
            onConfigClick={item.onClick}
            title={item.title}
            hoverTitle={item.hoverTitle}
          />
        );
      }

      // configbtn
      return (
        <ResultConfigurationMenu
          key={item.key}
          className="settings-item"
          onConfigClick={item.onClick}
          title={item.title}
          withSettings={withSettings}
        />
      );
    });
  }

  return (
    <Ui.Container ref={settingRef} withData={withData}>
      <div className="header">
        <h3>Opções</h3>
        <Button className="settings-closer" title="Fechar" onClick={() => handleClose()}>
          &times;
        </Button>
      </div>
      <div className="settings-body">
        {loading ? (<LoadingMenu className="settings-item" />) : renderSettinsMenu()}
      </div>
    </Ui.Container>
  );
}

CardSettings.propTypes = propTypes;
CardSettings.defaultProps = defaultProps;

export default CardSettings;
